import { BlockType, StaticField } from '@/lib/types';

export const FIELD_TYPES = [
  {
    id: BlockType.Text,
    name: 'Text',
    description: 'A single line of text.',
  },
  {
    id: BlockType.Numeric,
    name: 'Numeric',
    description: 'A numeric field allowing any number to be entered. This is an unformatted field.',
  },
  {
    id: BlockType.Date,
    name: 'Date & Time',
    description: 'A picker that allows selection of a date and optional time.',
  },
  {
    id: BlockType.Selection,
    name: 'Select List',
    description: 'A list of options to be selected from.',
  },
  {
    id: BlockType.Checkbox,
    name: 'Checkbox',
    description: 'A checkbox field.',
  },
  {
    id: BlockType.LongText,
    name: 'Text Editor',
    description: 'A text editor for longer text.',
  },
  {
    id: BlockType.Media,
    name: 'Media',
    description: 'Upload an image or a video.',
  },
  {
    id: BlockType.Section,
    name: 'Section',
    description: 'A section block.',
  },
  {
    id: BlockType.Link,
    name: 'Link',
    description: 'A link field.',
  },
];

export const STATIC_FIELDS = [
  StaticField.Name,
  StaticField.Description,
  StaticField.Media,
  StaticField.IsPublic,
  StaticField.CreatedDate,
  StaticField.UpdatedDate,
];

export const SPORTS = [
  {
    id: 1,
    name: 'Flag football',
  },
  {
    id: 2,
    name: 'Soccer',
  },
  {
    id: 3,
    name: 'Basketball',
  },
  {
    id: 4,
    name: 'Baseball',
  },
  {
    id: 5,
    name: 'Softball',
  },
  {
    id: 6,
    name: 'Field Hockey',
  },
  {
    id: 7,
    name: 'Volleyball',
  },
  {
    id: 8,
    name: 'Lacrosse',
  },
  {
    id: 9,
    name: 'Rugby',
  },
  {
    id: 10,
    name: 'Football',
  },
  {
    id: 11,
    name: 'Hockey',
  },
];
